import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getModel } from './selectors';
import * as actions from './actions';
import * as commonActions from '../actions';
import LoggerVisualisationComponent from './LoggerVisualisationComponent';

const LoggerVisualisationContainer = (props) => {
	return <LoggerVisualisationComponent {...props} />;
};

const mapStateToProps = (state) => {
	const model = getModel(state);
	return {
		model
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		actions: bindActionCreators({ ...actions, ...commonActions }, dispatch)
	};
};

const LoggerVisualisationContainerConn = connect(
	mapStateToProps,
	mapDispatchToProps
)(LoggerVisualisationContainer);

export default LoggerVisualisationContainerConn;
